(function() {
    const LOCALES = {
    EN: 'en',
    DE: 'de'
}

const FLAG_ASSETS = {
    [LOCALES.EN]: window.EN_FLAG_URL,
    [LOCALES.DE]: window.DE_FLAG_URL,
}

const localeValues = Object.values(LOCALES);

const pathHasDe = location.pathname === `/${LOCALES.DE}` || location.pathname.includes(`/${LOCALES.DE}/`);
const userLocale = pathHasDe ? LOCALES.DE : LOCALES.EN;

function changeLanguage(locale) {
    let newPath;
    if (locale === LOCALES.EN) newPath = location.href.replace(`/${LOCALES.DE}`, '');
    else newPath = location.href.replace(`/${location.hostname}`, `/${location.hostname}/${LOCALES.DE}`);
    
    window.location.href = newPath;
}

function toggleDropdown(btn) {
    const dropdownContainer = btn.closest('.sw-container').querySelector('.sw-dropdown-container');
    if (dropdownContainer.style.display === 'none') dropdownContainer.style.display = 'flex';
    else dropdownContainer.style.display = 'none';
}

function createLanguageSwitcher() {
    const swContainer = document.createElement("div");
    const swButtonContainer = document.createElement("div");
    const swDropdownContainer = document.createElement("div");
    const swBtnImg = document.createElement('img');

    swContainer.setAttribute('class', 'sw-container');
    swButtonContainer.setAttribute('class', 'sw-btn-container');
    swDropdownContainer.setAttribute('class', 'sw-dropdown-container');
    swDropdownContainer.style.display = 'none';

    swBtnImg.setAttribute('src', FLAG_ASSETS[userLocale] || FLAG_ASSETS[LOCALES.EN]);
    swButtonContainer.appendChild(swBtnImg);

    const availableLocales = localeValues.filter(item => item !== userLocale);
    availableLocales.forEach(locale => {
        const swLangImg = document.createElement('img');
        swLangImg.setAttribute('src', FLAG_ASSETS[locale] || FLAG_ASSETS[LOCALES.EN]);
        swLangImg.setAttribute('locale', locale);
        swDropdownContainer.appendChild(swLangImg);
    });

    swContainer.appendChild(swButtonContainer);
    swContainer.appendChild(swDropdownContainer);

    const langContainers = document.querySelectorAll('span[class*="ly-custom-"]');
    for (const item of langContainers) {
        const cloneSw = swContainer.cloneNode(true);
        item.appendChild(cloneSw);
    }
};

createLanguageSwitcher();

const swBtnContainers = document.querySelectorAll('.sw-btn-container img');
const swDropdownItems = document.querySelectorAll('.sw-dropdown-container img');

swBtnContainers.forEach(item => item.addEventListener('click', () => toggleDropdown(item)));
swDropdownItems.forEach(item => {
    const locale = item.getAttribute('locale');
    item.addEventListener('click', () => changeLanguage(locale));
})
})();